import { render } from "./QuestionOneScreen.vue?vue&type=template&id=6edcf12e&scoped=true&lang=html"
import script from "./QuestionOneScreen.vue?vue&type=script&lang=js"
export * from "./QuestionOneScreen.vue?vue&type=script&lang=js"

import "./QuestionOneScreen.vue?vue&type=style&index=0&id=6edcf12e&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edcf12e"]])

export default __exports__